import React from 'react';

import styles from './panelStyles';

import ReturnValue from 'buyside/components/presentation/ReturnValue/returnValue';
import Link, { LINK_TYPES } from 'buyside/components/presentation/Link/link';

const Panel = ({ header, headerUrl, symbol, tableData }) => {
  const renderData = row => {
    if (row.isReturn) {
      if (!row.data) return <span className={styles.na}>N/A</span>;
      return (
        <span>
          <ReturnValue value={row.data} />
        </span>
      );
    }
    return row.data ? row.data.toFixed(2) : <span className={styles.na}>N/A</span>;
  };

  return (
    <div className={styles.returnPanel}>
      <Link to={headerUrl} type={LINK_TYPES.PLAIN}>
        <h4>
          {header} {symbol !== '' && <small>({symbol})</small>}
        </h4>
      </Link>
      {tableData.map((row, i) => {
        return (
          <div className={styles.tableFlexRow} key={i}>
            <span className={styles.tableFlexRowHeading}>{row.label}:</span>
            <span className={styles.tableFlexValue}>{renderData(row)}</span>
          </div>
        );
      })}
    </div>
  );
};

export default Panel;
